// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const selectAllPipStatuses = () => ({
    type: actions.UPDATE_ALL_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS_SELECTIONS
});

export const selectPipStatuses = (status, isSelected) => ({
    isSelected,
    status,
    type: actions.UPDATE_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS_SELECTION
});




// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/action-creators/select-pip-statuses.js